import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ShippingAccountingRepository } from '../interfaces/shipping-accounting-repository.interface';

@Injectable()
export class DownloadShippingCsvUseCase {
  constructor(private readonly repository: ShippingAccountingRepository) {}

  execute(professionalId: string, startDate: string, endDate: string): Observable<Blob> {
    return this.repository.downloadCsv(professionalId, startDate, endDate);
  }
}
